import { noop } from "common/functions";
import { TransitionImage } from "common/ui/transitionImage";
import { onVideoTime } from "common/video";
import { load } from "eighth-animation/loader";
import { Scene } from "eighth-animation/scene/main";
import { toPath } from "eighth-animation/scene/resources";
import { VideoTailLooper } from "from-start/scene/4-360video/videoTailLooper";
import log from "loglevel";
import { Param } from "../common";
export async function start({ context, input, }) {
    const sound = await load({ progressCallback: noop });
    const transitionImage = new TransitionImage({
        parent: document.querySelector("#all-container"),
        imageURL: toPath("transition-image.jpg"),
    });
    const { videoElem, progressElem } = await input.waiter.wait();
    transitionImage.show();
    $(videoElem).hide();
    $(progressElem).hide();
    context.interactionVideoLoader.clearMovie("6번 영상.mp4");
    context.interactionVideoLoader.runWhenLoaded("7번 영상.mp4", async (elem) => {
        log.info("fifthvideo loaded elem is ", elem);
        videoElem.setAttribute("src", elem.src);
        videoElem.load();
    });
    const scene = new Scene();
    await scene.start({
        parentSelector: "#all-container",
        sound,
        transitionImage,
    });
    await context.interactionVideoLoader.wait("7번 영상.mp4");
    $(videoElem).show();
    $(progressElem).show();
    await videoElem.play();
    progressElem.run({ index: 6, video: videoElem, seconds: 60 * 2 });
    const looper = new VideoTailLooper({
        video: videoElem,
        from: 60 * 3 + 15,
        to: 60 * 3 + 18 + 4 / 30,
    });
    looper.run();
    const ret = new Param();
    onVideoTime({
        videoElement: videoElem,
        timeMillis: 60 * 2 * 1000,
        callback: () => {
            ret.fill({ videoElem, progressElem });
        },
    });
    return ret;
}
export async function skippedStart({ context, input, }) {
    const { videoElem, progressElem } = await input.waiter.wait();
    $(videoElem).hide();
    progressElem.fadeOutAndHide();
    await context.interactionVideoLoader.wait("7번 영상.mp4");
    $(videoElem).show();
    await videoElem.play();
    const ret = new Param();
    ret.fill({ videoElem, progressElem });
    return ret;
}
//# sourceMappingURL=main.js.map